"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Divider_1 = tslib_1.__importDefault(require("@mui/material/Divider"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const ChevronLeft_1 = tslib_1.__importDefault(require("@mui/icons-material/ChevronLeft"));
const ChevronRight_1 = tslib_1.__importDefault(require("@mui/icons-material/ChevronRight"));
const InternalComponents_1 = require("./InternalComponents");
const Sidebar_1 = tslib_1.__importDefault(require("./Sidebar"));
const SidebarIconButton_1 = tslib_1.__importStar(require("./SidebarIconButton"));
const sidebarSizeSm = 240;
const sidebarSizeMd = 320;
const SidebarLeft = (props) => {
    const { size = "md", children, header, open, onOpen, onClose, className, disableGutters = false, ...restOfSidebarProps } = props;
    const sidebarProps = {
        ...restOfSidebarProps,
        open,
        sx: theme => ({
            flexDirection: "column",
            width: !open && theme.spacing(7),
            flexBasis: open && `${size === "sm" ? sidebarSizeSm : sidebarSizeMd}px`,
            minWidth: open ? `${size === "sm" ? sidebarSizeSm : sidebarSizeMd}px` : theme.spacing(7),
        }),
        "aria-label": "Left sidebar",
    };
    return (react_1.default.createElement(Sidebar_1.default, { ...sidebarProps },
        react_1.default.createElement(Grid_1.default, { container: true, direction: "row", alignItems: "center" },
            open && header && (react_1.default.createElement(InternalComponents_1.SidebarTypographyHeader, { noWrap: true, sx: {
                    padding: theme => theme.spacing(1, 0, 1, 1),
                    maxWidth: `calc(100% - ${SidebarIconButton_1.SIDEBAR_ICON_BUTTON_WIDTH}px)`,
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    display: "block",
                } }, header)),
            !open && (react_1.default.createElement(SidebarIconButton_1.default, { "aria-label": "Open left sidebar", onClick: onOpen },
                react_1.default.createElement(ChevronRight_1.default, null))),
            open && (react_1.default.createElement(SidebarIconButton_1.default, { "aria-label": "Close left sidebar", onClick: onClose, sx: { ml: "auto" } },
                react_1.default.createElement(ChevronLeft_1.default, null)))),
        open && react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(Grid_1.default, { container: true, sx: theme => ({
                overflowX: "hidden",
                whiteSpace: "normal",
                p: disableGutters ? theme.spacing(1, 0) : 1,
            }) }, children)));
};
exports.default = SidebarLeft;
